module.exports = __webpack_public_path__ + "img/badge-percent.02447b8a.svg";